import React, { useContext, useState, useEffect } from 'react';
import { Carousel } from 'react-responsive-carousel';
import { Box, Button, Typography } from '@mui/material';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import i18n from 'i18next';
import useWindowSize from 'utils/useWindowSize';
import { GlobalContext } from 'context';
import { useTranslation } from 'react-i18next';
import Link from 'next/link';

const Slider = ({ linkData, interval = 5000 }) => {
    const { sizes } = useWindowSize();
    const { t } = useTranslation();

    const { state } = useContext(GlobalContext);

    const [activeIndex, setActiveIndex] = useState(0);

    const handleChangeSlide = (index) => {
        setActiveIndex(index);
    };

    useEffect(() => {
        if (linkData.length > 0) {
            // Prevent running if no data is available

            const timer = setInterval(() => {
                setActiveIndex((prevIndex) => (prevIndex + 1) % linkData.length);
            }, interval);

            // Clear the interval when the component is unmounted or when `interval` or `linkData.length` changes
            return () => clearInterval(timer);
        }
    }, [linkData.length, interval]);

    return (
        <Carousel
            showThumbs={false}
            infiniteLoop
            useKeyboardArrows
            interval={interval}
            selectedItem={activeIndex}
            onChange={handleChangeSlide}
            autoPlay
        >
            {linkData && linkData.length > 0 ? (
                linkData.map((item, index) => (
                    <div key={item.id}>
                        <div
                            style={{
                                height: 525,
                                width: '100%',
                                margin: '0 auto',background: `linear-gradient(
  to right,
  rgba(2, 70, 95, 0.9) 20%,   // primary darker tint
  rgba(4, 90, 121, 0) 80%
)`,

                                background: `linear-gradient(to right, rgba(7, 9, 9, 0.6) 10%, rgba(15, 54, 133, 0) 80%)`,
                                position: 'absolute',
                            }}
                        ></div>
                        <div
                            style={{
                                height: 525,
                                width: '100%',
                                margin: '0 auto',
                                backgroundImage: `url(${item.imageUrl})`,
                                backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat',
                                backgroundSize: 'cover',
                            }}
                        >
                            <Box
                                className={`absolute bottom-0 left-0 max-w-[700px] text-left flex flex-col ${sizes.sm ? 'm-6 mb-16' : 'm-20'} transition-all duration-500 ${activeIndex === index ? 'animate-slide-fade-in' : 'animate-slide-fade-out'}`}
                            >
                                <Typography
                                    variant="body16"
                                    className="text-white border-secondary-200"
                                    style={{
                                        fontSize: sizes.sm ? 18 : 36,
                                        display: '-webkit-box',
                                        WebkitBoxOrient: 'vertical',
                                        WebkitLineClamp: 3,
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        width: '100%',
                                        borderLeft: '1px solid',
                                        paddingLeft: 20,
                                    }}
                                >
                                    {state.auth.lang === 'mn' ? item.name : item.nameEng}
                                </Typography>
                                <Typography
                                    variant={sizes.sm ? 'h30' : 'h61'}
                                    className="text-white"
                                    style={{
                                        marginTop: 20,
                                        fontSize: sizes.sm ? 12 : 18,
                                        display: '-webkit-box',
                                        WebkitBoxOrient: 'vertical',
                                        WebkitLineClamp: 3,
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        width: '100%',
                                    }}
                                >
                                    {state.auth.lang === 'mn'
                                        ? item.description
                                        : item.descriptionEng}
                                </Typography>

                                <Link
                                    href={'/news/' + item.id}
                                    passHref
                                    className="text-[12px]  mt-5 uppercase bg-white text-[#1e1c55] w-40 p-3 text-center rounded-lg cursor-pointer hover:bg-secondary-200 transition-colors duration-300"
                                >
                                    {t('read_more')}
                                </Link>
                            </Box>
                        </div>
                    </div>
                ))
            ) : (
                <div>
                    <div
                        style={{
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',

                            height: 425,
                            width: '100%',
                            margin: '0 auto',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',

                            height: 425,
                            width: '100%',
                            margin: '0 auto',
                            backgroundImage: `url(/path/to/default/image.jpg)`,
                        }}
                    ></div>
                </div>
            )}
        </Carousel>
    );
};

export default Slider;
